function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_c('strong',[_vm._v("Online marketing meets "),_c('br'),_vm._v(" Business intelligence")])]),_vm._v(" "),_c('p',[_vm._v("Our goal is to allow business owners track easily and make informed decisions about their online sales funnel and your online marketing.\nWhiteBox provides "),_c('strong',[_vm._v("online sales funnel")]),_vm._v(" performance insights to business owners running "),_c('strong',[_vm._v("offline service SMEs")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Measure how your online presence affects your bottom line. Combine your customer online and offline interactions and know which online activities deliver the best results!")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/home","image":"/img/intro.svg","summary":"Combine your customer online and offline interactions"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }